import { Injectable } from '@angular/core';
import * as appApiResources from '../../shared/globalcontants';
import { CommonService } from '../../shared/services/common.service';
import { PopupComponent } from '../../shared/popup/popup.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { APIServiceProviderService } from '../services/APIServices/APIServiceProviderService/APIServiceProviderService';


@Injectable({
  providedIn: 'root'
})
export class BarcodAutoGeneratorServiceService {
  tounitCode: string;
  fromUnitName: string;
  UnitTypeNames: any;//= this._ts.instant('noMath');
  toUnitName: string;
  fromUnitCode: string;
  soundMode: string;
  // audio = new AudioContext()


  constructor(public _CommonService: CommonService, private dialog: MatDialog, private _ts: TranslateService,
    private apiServiceProviderService: APIServiceProviderService,
    ) {
  this.soundMode = window.localStorage.getItem('soundmode');
  this.UnitTypeNames = this._ts.instant('noMath');
  }

  updateHistoryForQty(inventoryObjForUpdate, calculateQty, initialQty) {
    this._CommonService.updatedQuantity =
    parseFloat(this.apiServiceProviderService.utilityService.DecimalFormatter.format(calculateQty).toString().split(',').join(''));
    let existingHistory = [];
    this._CommonService.noMathHistory.subscribe(value => {
      // console.log(value);
      existingHistory = value;
    });
    existingHistory = inventoryObjForUpdate.noMathHistory;
    const lists = {
      'initialQty': `${initialQty ? this.apiServiceProviderService.utilityService.DecimalFormatter.format(Number(initialQty)) : '0.00'} ${this.tounitCode}`,
      // "initialQty": `${localActualQuantity ? localActualQuantity : '0.00'} ${this.tuCode}`,
      'endQty': `${this.apiServiceProviderService.utilityService.DecimalFormatter.format(calculateQty)} ${this.tounitCode}`,
      'details': []
    };
    const history = [];
    const countValue = 1;
    const unitValue = {'count': this.apiServiceProviderService.utilityService.DecimalFormatter.format(countValue),
              'unit': this.fromUnitCode,
              'unitName': this.fromUnitName, 'fromBarCode': true
  };
    history.push(unitValue);
    lists.details = history;
    if (existingHistory && existingHistory.length > 0) {
      existingHistory.push(lists);
    } else {
      existingHistory = [];
      existingHistory[0] = lists;
    }
    // this._CommonService.noMathHistory.next(existingHistory);
    inventoryObjForUpdate.noMathHistory = existingHistory;
    inventoryObjForUpdate.disableDetails = false;
    inventoryObjForUpdate.addQuantity = true;
    this._CommonService.editedItem = inventoryObjForUpdate;
    this._CommonService.addQuantity = true;
    this._CommonService.noMathHistory.next(existingHistory);
    return inventoryObjForUpdate;
  }


  updateTableDataQty(InventoryBarCodeDetail, UnitsDetails, inventoryObjForUpdate, searchedbarcode, fromUnit = 'Transaction') {
    if ((typeof(inventoryObjForUpdate.quantity) === 'string') ? inventoryObjForUpdate.quantity === '' : false) {
      inventoryObjForUpdate.quantity = '0';
    }
    const initialQty = inventoryObjForUpdate.quantity !== null ? inventoryObjForUpdate.quantity : 0;
    const caluatedQty = this.calculateQty(inventoryObjForUpdate, UnitsDetails, searchedbarcode, fromUnit);
    const finalCalculatedQty = parseFloat(initialQty) + caluatedQty;
    inventoryObjForUpdate.quantity =  this.apiServiceProviderService.utilityService.DecimalFormatter.format(finalCalculatedQty).toString();
    const updatedInventoryWithhistory = this.updateHistoryForQty(inventoryObjForUpdate, finalCalculatedQty, initialQty);
    return updatedInventoryWithhistory;

    // if(caluatedQty == false){
    //   return inventoryObjForUpdate;
    // }else{
    //   let finalCalculatedQty = parseFloat(initialQty) + caluatedQty;
    //   inventoryObjForUpdate.quantity =  (finalCalculatedQty).toFixed(2).toString();
    //   let updatedInventoryWithhistory = this.updateHistoryForQty(inventoryObjForUpdate,finalCalculatedQty,initialQty);
    //   return updatedInventoryWithhistory;
    // }
  }

  calculateQty(inventoryObjForUpdate, UnitsDetails, searchedbarcode, fromUnit) {
    const searchedbarcodeDetails =  inventoryObjForUpdate;
    const _unitTypeID = UnitsDetails.find(
      x => x.UnitId === searchedbarcodeDetails.unitId && x.UnitCode === searchedbarcodeDetails.unit) ? UnitsDetails.find(
        x => x.UnitId === searchedbarcodeDetails.unitId && x.UnitCode === searchedbarcodeDetails.unit).UnitTypeId : -1;

    const fromUnitConverstion = (searchedbarcodeDetails === undefined || searchedbarcodeDetails == null || _unitTypeID === -1)
     ? fromUnit === 'Transaction' ? UnitsDetails.find(x => x.UnitTypeId === appApiResources.UnitType.TransactionUnit).Conversion
      :  UnitsDetails.find(x => x.UnitTypeId === appApiResources.UnitType.BaseUnit).Conversion : searchedbarcodeDetails.packSize;
    this.fromUnitName = (searchedbarcodeDetails === undefined || searchedbarcodeDetails == null ||  _unitTypeID === -1) ? fromUnit === 'Transaction' ? this.UnitTypeNames.transactionUnit : this.UnitTypeNames.baseUnit : this.GetUnitTypeName(_unitTypeID) ; // searchedbarcodeDetails.UnitName;
    this.fromUnitCode = (searchedbarcodeDetails === undefined || searchedbarcodeDetails == null ||  _unitTypeID === -1) ? fromUnit === 'Transaction' ? UnitsDetails.find(x => x.UnitTypeId === appApiResources.UnitType.TransactionUnit).UnitCode : UnitsDetails.find(x => x.UnitTypeId === appApiResources.UnitType.BaseUnit).UnitCode : searchedbarcodeDetails.unit;
    const toUnitConverstion = fromUnit === 'Transaction' ? UnitsDetails.find(
      x => x.UnitTypeId === appApiResources.UnitType.TransactionUnit).Conversion : UnitsDetails.find(
        x => x.UnitTypeId === appApiResources.UnitType.BaseUnit).Conversion;
    this.tounitCode = fromUnit === 'Transaction' ? UnitsDetails.find(
      x => x.UnitTypeId === appApiResources.UnitType.TransactionUnit).UnitCode : UnitsDetails.find(
        x => x.UnitTypeId === appApiResources.UnitType.BaseUnit).UnitCode;
    this.toUnitName = fromUnit === 'Transaction' ? this.UnitTypeNames.transactionUnit : this.UnitTypeNames.baseUnit;
    return (searchedbarcodeDetails.barcodeConversion / toUnitConverstion);

    // if(_unitTypeID == -1){
    //   this.showWarnig();
    //   return false;
    // } else {

    //   this.fromUnitName = (searchedbarcodeDetails == undefined || searchedbarcodeDetails == null)
    // ? this.UnitTypeNames.transactionUnit : this.GetUnitTypeName(_unitTypeID) ; //searchedbarcodeDetails.UnitName;
    //   this.fromUnitCode = (searchedbarcodeDetails == undefined || searchedbarcodeDetails == null)
    // ? UnitsDetails.find(x=>x.UnitTypeId == appApiResources.UnitType.TransactionUnit).UnitCode : searchedbarcodeDetails.UnitCode;
    //   let toUnitConverstion = UnitsDetails.find(x=>x.UnitTypeId == appApiResources.UnitType.TransactionUnit).Conversion;
    //   this.tounitCode = UnitsDetails.find(x=>x.UnitTypeId == appApiResources.UnitType.TransactionUnit).UnitCode;
    //   this.toUnitName = this.UnitTypeNames.transactionUnit;
    //   return ((1*fromUnitConverstion)/toUnitConverstion);
    // }
  }

  GetUnitTypeName(unitTypeId) {
    let unitName;
    switch (unitTypeId) {
      case 0:
      unitName = this.UnitTypeNames.baseUnit; break;
      case 1:
      unitName = this.UnitTypeNames.purchaseUnit; break;
      case 2:
      unitName = this.UnitTypeNames.transactionUnit; break;
      case 3:
      unitName = this.UnitTypeNames.recipeUnit; break;
      default:
      unitName = 'Unknown';
      break;
    }
    return unitName;
  }

  showWarnig() {
    const dialogArray = { headerText: this._ts.instant('common.warning'),
     contentText: this._ts.instant('common.barcodeMismatch'),
      confirmText: this._ts.instant('common.ok'),
      confirmHelpText: 'OK',
      cancelHelpText: 'CANCEL' };

    this._CommonService.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent,
      this._CommonService.mobilePopUpProperty
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        switch (result) {
          case 'OK':  break;
        }
      }
    });
  }

  // beep(vol, freq, duration,audiotype){
  //   let v=this.audio.createOscillator()
  //   let u=this.audio.createGain()
  //   v.connect(u)
  //   v.frequency.value=freq
  //   v.type=audiotype
  //   u.connect(this.audio.destination)
  //   console.log(this.audio.destination)
  //   u.gain.value=vol*0.01
  //   v.start(this.audio.currentTime)
  //   console.log(this.audio.currentTime)
  //   v.stop(this.audio.currentTime+duration*0.001)
  //   }

    // onAudioPlay(isSuccess)
    // {
    //  let audiotype = "square";
    //  this.beep(100,520,200,audiotype);
    // }

    onAudioPlay(isSuccess) {
      // let soundMode = typeof(this._CommonService.soundMode) == 'string' ?
      // this._CommonService.soundMode : this._CommonService.soundMode['id'];
      this.soundMode = window.localStorage.getItem('soundmode');
      if (this.soundMode === 'true') {
        const sound = isSuccess === true ? 'assets/BeepAudio/success.mp3' : 'assets/BeepAudio/failure.mp3';
        const audio = new Audio(sound) ;
        audio.play();
      }
    }
}
